"use client";

import { ProductsAndServicesPageQueryResult } from "@/sanity.types";

type HeroBtnProps = {
	ctaText: NonNullable<ProductsAndServicesPageQueryResult>["header"]["ctaText"];
	scrollToSectionId: string;
	offsetNumber?: number;
};

export default function HeroBtn({ ctaText, scrollToSectionId, offsetNumber = 30 }: HeroBtnProps) {
	const handleScrollToSection = () => {
		const element = document.getElementById(scrollToSectionId);
		if (element) {
			const elementPosition = element.offsetTop - offsetNumber;
			window.scrollTo({
				top: elementPosition,
				behavior: "smooth",
			});
		}
	};

	return (
		<button className="flex cursor-pointer items-center gap-x-5" onClick={handleScrollToSection} aria-label="Scroll to section">
			<div className="border-brown-middle relative flex h-[1.875rem] w-[1.875rem] items-center justify-center rounded-full border-2 sm:h-[3.25rem] sm:w-[3.25rem]">
				<svg
					className="absolute top-1.5 left-1/2 h-4.5 w-4 -translate-x-1/2 animate-bounce sm:top-[0.719rem] sm:h-[1.938rem] sm:w-[1.688rem]"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 32 29"
					fill="none"
				>
					<path
						d="M17.6595 26.9517L31.6016 13.0096L29.942 11.35L18.8078 22.4842C18.1741 23.1179 17.0912 22.6686 17.0912 21.7735L17.0912 0.789062L14.7443 0.789062L14.7443 21.6058C14.7443 22.5027 13.6614 22.9502 13.0277 22.3166L2.06114 11.35L0.401567 13.0096L14.3437 26.9517L16.0032 28.6112L17.6628 26.9517L17.6595 26.9517Z"
						fill="#B19780"
					/>
				</svg>
			</div>
			<span className="text-cap-s sm:text-cap-m text-white">{ctaText}</span>
		</button>
	);
}
